import { useEffect, useState } from "react";

import { sortByField } from "../../utils/Sort";

import "./KochLocationFilter.css";
import NitroFilter from "../NitroFilter";
import { OccupantsIcon } from "../../icons";
import NitroService from "../../utils/nitro.service";

const KochLocationFilter = ({
  value,
  setValue,
  // variant,
  config,
  isMobile,
}: {
  value: string;
  setValue: (value: string) => void;
  config?: {
    customPaper?: boolean;
    shadow?: boolean;
    opaque?: boolean;
    autoFocus?: boolean;
    inputRef?: React.MutableRefObject<any> | null;
    valueRequired?: boolean;
  };
  isMobile?: boolean;
}) => {
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    [],
  );

  const load = async () => {
    const records = await NitroService.getKochLocations();

    const sorted = [
      { label: "", value: "" },
      ...sortByField(
        records.map((r) => {
          return { label: r.name || "", value: r.name || "" };
        }),
        "label",
        "ASC",
      ),
    ];

    setOptions(sorted);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <NitroFilter
      placeholder="Koch Location"
      size="small"
      data={{ options }}
      value={value}
      setValue={setValue}
      isMobile={isMobile}
      config={config}
      Icon={<OccupantsIcon color="#383838" />}
    />
  );
};

export default KochLocationFilter;
